import React from 'react';
import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { LOCATION_OFFLINE } from 'bento-ordering/locations/constants/paths';
import logError from 'bento-ordering/utils/logError';

/**
 * This is an error boundary component which acts as a try catch for component.
 * If any exception is thrown using this component will allow us to fallback
 * to the offline page instead of completely breaking the application. Error boundaries
 * only catch error below them in the dom tree.
 *
 * Usage:
 * <ErrorBoundary>
 *  <CartContainer>
 * <ErrorBoundary>
 */
class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node
  };

  state = {
    hasError: false
  };

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // log error to sentry and datadog
    logError(error.toString(), errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <Redirect to={LOCATION_OFFLINE} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
